// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"805":"aff83442","904":"e7ed598a"}[chunkId] + ".css";
};